// Toggle tracking of change indicator DOM positions and connectors overlay rendering
export const ENABLED = true

export const CORNER_RADIUS = 4

export const INTERACTIVE_STROKE_WIDTH = 16

export const CONNECTOR_MARGIN = 8
export const ARROW_MARGIN_X = 8
export const ARROW_MARGIN_Y = 2
export const ARROW_SIZE = 4
export const ARROW_THRESHOLD = 12
export const STROKE_WIDTH = 2

export const DEBUG = false
export const DEBUG_LAYER_BOUNDS = DEBUG || false
